import { render, staticRenderFns } from "./ActivateConfig.vue?vue&type=template&id=1f6719d8&scoped=true"
import script from "./ActivateConfig.vue?vue&type=script&lang=js"
export * from "./ActivateConfig.vue?vue&type=script&lang=js"
import style0 from "./ActivateConfig.vue?vue&type=style&index=0&id=1f6719d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6719d8",
  null
  
)

/* custom blocks */
import block0 from "./ActivateConfig.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports